/**
 * Telegram bot link API client (ADR-009 Phase 3).
 *
 * Frontend flow:
 *   1. const { deep_link } = await beginTelegramLink()
 *   2. window.open(deep_link) — открывается t.me/<bot>?start=link_<token>
 *   3. Пользователь жмёт «Запустить» в Telegram
 *   4. Бот /start link_<token> → server binds Employee.telegram_id → chat_id
 *   5. Frontend поллит getTelegramLinkStatus() каждые 2-3 секунды,
 *      ждёт linked: true → показывает success
 */

import { apiFetch } from './core'

export function beginTelegramLink() {
    return apiFetch('/telegram-link/begin', { method: 'POST' })
}

export function getTelegramLinkStatus() {
    return apiFetch('/telegram-link/status')
}

export function unlinkTelegram() {
    return apiFetch('/telegram-link', { method: 'DELETE' })
}
